import { returnError400WithEmptyPayload, returnNoErrorWithPayload } from '../model/model';
export const MOCK_RestFieldDetails_NULLID = {
    id: null,
    name: 'NULL',
    description: 'NULL',
    key: 'NULL',
    isLocked: false,
    searcherKey: 'NULL',
    screensCount: 1,
    contextsCount: 2,
    schema: {
        type: 'foo',
        system: undefined,
        items: undefined,
        custom: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
        customId: undefined,
    },
};
export const MOCK_RestFieldDetails_ONE = {
    id: 'customfield_0001',
    name: 'ONE',
    description: 'ONE',
    key: 'ONE',
    isLocked: false,
    searcherKey: 'foo',
    screensCount: 1,
    contextsCount: 2,
    schema: {
        type: 'foo',
        system: undefined,
        items: undefined,
        custom: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
        customId: undefined,
    },
};
export const MOCK_RestFieldDetails_TWO = {
    id: 'customfield_0002',
    name: 'TWO',
    description: 'TWO',
    key: 'TWO',
    isLocked: false,
    searcherKey: 'two',
    screensCount: 1,
    contextsCount: 2,
    schema: {
        type: 'foo',
        system: undefined,
        items: undefined,
        custom: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
        customId: undefined,
    },
};
export class MOCKED_LICENSE_SERVICE_INVALID {
    enforceValidLicense(_context) {
        return returnError400WithEmptyPayload('invalid license', 'MKDERR_2323232');
    }
}
export class MOCKED_LICENSE_SERVICE_VALID {
    enforceValidLicense(_context) {
        return returnNoErrorWithPayload(null);
    }
}
